"use client";

import { useFeatureFlag } from "@posthog/next";
import { useEffect, useState } from "react";

/**
 * PostHog flag key for the org-level outcomes library UI
 * (Knowledge Outcomes tab, script outcome refs, script-sourced redialing).
 * Create this flag in PostHog before enabling for orgs.
 */
export const ORG_OUTCOMES_FEATURE_FLAG = "ui-org-outcomes";

/**
 * Mount-gated org-outcomes flag. `enabled` stays false until after mount
 * (avoids React #418); `ready` flips true once the gate has settled so
 * route redirects can wait before treating Outcomes as denied.
 *
 * With the flag **off**: legacy redialing UX, no Knowledge Outcomes tab,
 * scripts behave as today. With the flag **on**: new surfaces enabled
 * incrementally per GAIL-488+ UI issues.
 */
export function useOrgOutcomesFlag(): { enabled: boolean; ready: boolean } {
  const flagEnabled =
    useFeatureFlag(ORG_OUTCOMES_FEATURE_FLAG)?.enabled === true;
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  return { enabled: ready && flagEnabled, ready };
}

/** Convenience boolean — false until mount, then mirrors the PostHog flag. */
export function useOrgOutcomesEnabled(): boolean {
  return useOrgOutcomesFlag().enabled;
}
